import { mesaColorNames } from '@/src/common/theme'
import Svg, { Path, type SvgProps } from 'react-native-svg'

const ReturnIcon = (props: SvgProps) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <Path
      d="M3.33301 1.6665V18.3332L4.99967 17.4998L6.66634 18.3332L8.33301 17.4998L9.99967 18.3332L11.6663 17.4998L13.333 18.3332L14.9997 17.4998L16.6663 18.3332V1.6665L14.9997 2.49984L13.333 1.6665L11.6663 2.49984L9.99967 1.6665L8.33301 2.49984L6.66634 1.6665L4.99967 2.49984L3.33301 1.6665Z"
      stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M13.3337 6.6665H8.33366C7.89163 6.6665 7.46771 6.8421 7.15515 7.15466C6.84259 7.46722 6.66699 7.89114 6.66699 8.33317C6.66699 8.7752 6.84259 9.19912 7.15515 9.51168C7.46771 9.82424 7.89163 9.99984 8.33366 9.99984H11.667C12.109 9.99984 12.5329 10.1754 12.8455 10.488C13.1581 10.8006 13.3337 11.2245 13.3337 11.6665C13.3337 12.1085 13.1581 12.5325 12.8455 12.845C12.5329 13.1576 12.109 13.3332 11.667 13.3332H6.66699"
      stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M10 14.5832V5.4165"
      stroke={props.color ?? mesaColorNames['Mesa - Brand/Secondary #223843']}
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export default ReturnIcon
